import { IAction } from '~/redux/interfaces';
import { IUserReducer, typeUpdateUser } from '~/redux/modules/user/user.interface';

export function actionUpdateUser(user: IUserReducer): IAction<IUserReducer> {
   return {
      type: typeUpdateUser,
      payload: user,
   };
}
